import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import Link from '../../components/Navigation/Link'
import Brand from './Sidebar.brand'
import { resolveMenuIcons } from '../../config/settings/menuIcons'
import routes from '../../config/settings/routes'
import { useAcl } from '../AccessControlList/acl.hook'
import {
  Container,
  LinkName,
  SidebarMenuContainer,
  Nav,
  NavLabel,
  NavbarLinkContainer,
  NavbarMenu,
  MenuLink,
  MenuIconWrapper,
  HelpSection,
} from './Sidebar.styles'

const Sidebar = () => {
  const { menus } = useSelector((state) => state.acl)
  const { isAdmin } = useAcl()
  const location = useLocation()

  const visibleMenus = useMemo(
    () =>
      resolveMenuIcons(
        [...menus]
          .filter((menu) => menu.isActive)
          .sort((a, b) => (a.orderIndex ?? 999) - (b.orderIndex ?? 999))
      ),
    [menus]
  )

  const isHelpActive =
    location.pathname === routes.help ||
    location.pathname.startsWith(`${routes.help}/`)
  const isSupportActive =
    location.pathname === routes.support ||
    location.pathname.startsWith(`${routes.support}/`)

  return (
    <Container>
      <Brand />
      <SidebarMenuContainer>
        <Nav aria-label="Menú principal">
          <NavLabel>Menú</NavLabel>
          <NavbarLinkContainer>
            {visibleMenus.map(({ id, name, path, icon }) => {
              const isRouteActive =
                path === '/'
                  ? location.pathname === '/'
                  : location.pathname === path ||
                    location.pathname.startsWith(`${path}/`)

              return (
                <NavbarMenu key={id} $active={isRouteActive}>
                  <MenuLink $active={isRouteActive}>
                    <Link path={path}>
                      <MenuIconWrapper $active={isRouteActive}>
                        <span className={icon} aria-hidden="true" />
                      </MenuIconWrapper>
                      <LinkName $active={isRouteActive}>{name}</LinkName>
                    </Link>
                  </MenuLink>
                </NavbarMenu>
              )
            })}
          </NavbarLinkContainer>
        </Nav>

        <HelpSection aria-label="Ayuda">
          <NavLabel>Ayuda</NavLabel>
          <NavbarLinkContainer>
            <NavbarMenu $active={isHelpActive}>
              <MenuLink $active={isHelpActive}>
                <Link path={routes.help}>
                  <MenuIconWrapper $active={isHelpActive}>
                    <span className="las la-life-ring" aria-hidden="true" />
                  </MenuIconWrapper>
                  <LinkName $active={isHelpActive}>Contacto</LinkName>
                </Link>
              </MenuLink>
            </NavbarMenu>
            {isAdmin && (
              <NavbarMenu $active={isSupportActive}>
                <MenuLink $active={isSupportActive}>
                  <Link path={routes.support}>
                    <MenuIconWrapper $active={isSupportActive}>
                      <span className="las la-headset" aria-hidden="true" />
                    </MenuIconWrapper>
                    <LinkName $active={isSupportActive}>Tickets</LinkName>
                  </Link>
                </MenuLink>
              </NavbarMenu>
            )}
          </NavbarLinkContainer>
        </HelpSection>
      </SidebarMenuContainer>
    </Container>
  )
}

export default Sidebar
